<template>
    <div class="Information">
        <div class="row">
            <div class="container-fluid">
                <div class="row record-section-row">
                    <div class="col">
                        <div>
                            <FamilyApprovalTimeline :record-id="RecordData.Id"
                                                    edit-permission-requirement=""
                                                    view-permission-requirement=""
                                                    :edit-mode="EditMode"
                                                    :record-data="RecordData" />
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" permission="" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    //import DateEditor from '../../../../Core/ItemEditors/DateEditor.vue';
    //import DateEditorRequest from '../../../../Core/ItemEditors/DateEditorRequest.vue';
    //import StringEditor from '../../../../Core/ItemEditors/StringEditor.vue';
    //import IntegerEditor from '../../../../Core/ItemEditors/IntegerEditor.vue';
    //import SelectEditor from '../../../../Core/ItemEditors/SelectEditor.vue';
    //import SelectEditorRequest from '../../../../Core/ItemEditors/SelectEditorRequest.vue';
    //import StatusEditor from './StatusEditor.vue';
    import EditMode from '../../../../Core/ItemEditors/EditMode.vue';
    import FamilyApprovalTimeline from './FamilyApprovalTimeline.vue';

    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                Agencies: [],
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
        },
        components: {
            //DateEditor,
            //DateEditorRequest,
            //StringEditor,
            //IntegerEditor,
            //SelectEditorRequest,
            EditMode,
            //SelectEditor,
            //StatusEditor,
            FamilyApprovalTimeline
        },
        mounted() {

        },
        computed: {

        }
    }
</script>

<style scoped>
</style>